import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

//import ScrollHandler from "../ScrollHandler";

import ListingOverview from "./overview/ListingOverview";
import RelatedListings from "./related/RelatedListings";

import PathHelper from "../../PathHelper";
import ListingDetailsHeader from "./ListingDetailsHeader";

import {
	fetchMarketListingById,
	fetchMarketListings,
} from "../../../../_redux/actions/market";
import ListingDetailsPreview from "./preview/ListingDetailsPreview";
import { MarketPlaceProvider } from "../MarketPlaceContext";

import s from "./ListingDetails.module.scss";

export default function ListingDetails() {
	//const location = useLocation();
	const dispatch = useDispatch();
	const history = useHistory();
	const { id } = useParams() || {};

	const [section, setSection] = useState("");
	const [product, setProduct] = useState({});
	const [showPreview, setShowPreview] = useState(false);

	const market = useSelector((state) => state.market || {});
	const user = market.user;
	const relatedProducts = (market.listings || []).filter(
		(p) => p.id !== 1 * id
	);
	const listing = market.listing;

	/* useEffect(() => {
		setSection(location.hash.substring(1));
	}, [location]); */

	useEffect(() => {
		if (listing) {
			setProduct(listing);

			// Get related listings
			dispatch(fetchMarketListings({ categories: [listing.category] }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [listing]);

	useEffect(() => {
		dispatch(fetchMarketListingById(id));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const tabs = [
		{
			name: "Overview",
			url: `#overview`,
			isActive: section === "overview",
		},
		{ name: "Lineage", url: `#lineage`, isActive: section === "lineage" },
		{
			name: "Other Datasets Like This",
			url: `#related`,
			isActive: section === "related",
		},
	];

	// ------------------------------------- INIT -------------------------------------
	const viewCategoryProducts = () => {
		const path = PathHelper.getPath("market", "");

		history.push(
			`${path}?category=${encodeURIComponent(
				product.category?.toLocaleLowerCase()
			)}`
		);
	};

	return showPreview ? (
		<ListingDetailsPreview
			product={product}
			goBack={() => setShowPreview(false)}
		/>
	) : (
		<MarketPlaceProvider
			value={{
				showHomeIcon: true,
			}}
		>
			<div className={s.root}>
				<ListingDetailsHeader
					product={product}
					user={user}
					tabs={tabs}
					onPreview={
						product?.marketPreviewFile ? () => setShowPreview(true) : null
					}
				/>

				{/* <ScrollHandler location={location} /> */}

				<div className={s.pageContent}>
					<ListingOverview
						product={product}
						updateSection={(s) => setSection(s)}
						viewCategoryProducts={viewCategoryProducts}
					/>

					{/* <ListingLineage
					product={product}
					updateSection={(s) => setSection(s)}
				/> */}

					<RelatedListings
						product={product}
						products={relatedProducts}
						updateSection={(s) => setSection(s)}
						viewCategoryProducts={viewCategoryProducts}
					/>
				</div>
			</div>
		</MarketPlaceProvider>
	);
}
